import axios from './axios'

export default class BlogService{
    static async list(query={}){
        return await axios.get("blog/list",{
            params:query
        })
    }
    static async detail(slug){
        return await axios.get("blog/details/"+slug)
    }

    static async category(){
        return await axios.get('/blog/category/list')
    }
}
